import React, { useState, useEffect } from 'react';
import { FormDateRangePicker } from 'shared/formControls';

const defaultValue = {
  start: null,
  end: null,
};

const DateRangeFilterCell = ({ value, onChange }) => {
  const [selectedRange, setSelectedRange] = useState(value);

  const handleChange = (event) => setSelectedRange(event.value ? event.value : defaultValue);

  const handlePopupClose = () => {
    if (!selectedRange?.start || !selectedRange?.end) {
      setSelectedRange(defaultValue);
      onChange({
        value: null,
      });
      return;
    }
    onChange({
      value: selectedRange,
    });
  };

  useEffect(() => {
    setSelectedRange(value || defaultValue);
  }, [value]);

  const dateInputSettings = { width: 125, label: '', formatPlaceholder: 'short' };

  return (
    <div className='k-filtercell'>
      <FormDateRangePicker
        onChange={handleChange}
        value={selectedRange}
        startDateInputSettings={{ ...dateInputSettings, placeholder: 'Start Date' }}
        endDateInputSettings={{ ...dateInputSettings, placeholder: 'End Date' }}
        popupSettings={{
          onClose: handlePopupClose,
        }}
      />
    </div>
  );
};

export default DateRangeFilterCell;
